import { isMobile } from '../DeviceDetect';

export default class DragScroll {
    constructor({ className = '' }) {
        if (isMobile) {
            return;
        }

        this.classActive = 'active';
        this.container = document.getElementsByClassName(className)[0];

        this.init();
    }

    init() {
        this.container.addEventListener('mousedown', this.onMousedown);
        document.addEventListener('mouseup', this.onMouseup);

        this.isDrag = false;
        this.mx = 0;
    }

    mousemove = (event) => {
        const mx2 = event.pageX - this.container.offsetLeft;

        if(this.mx) {
            this.container.scrollLeft = this.sx + this.mx - mx2;
        }
    }

    onMousedown = (event) => {
        this.isDrag = true;
        this.sx = this.container.scrollLeft;
        this.mx = event.pageX - this.container.offsetLeft;

        this.container.addEventListener('mousemove', this.mousemove);
        this.container.classList.add(this.classActive);
    }

    onMouseup = () => {
        if (!this.isDrag) {
            return;
        }

        this.container.removeEventListener('mousemove', this.mousemove);
        this.container.classList.remove(this.classActive);
        this.isDrag = false;
        this.mx = 0;
    }

    destroy() {
        if (!this.container) {
            return;
        }

        this.container.removeEventListener('mousedown', this.onMousedown);
        this.container.removeEventListener('mousemove', this.mousemove);
        document.removeEventListener('mouseup', this.onMouseup);
        this.container.classList.remove(this.classActive);
        this.isDrag = false;
        this.mx = 0;
    }
}
